import styled from 'styled-components';

interface ErrorMessageProps {
  visible: boolean;
}

export const Label = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #484848;
  display: block;
  margin-bottom: 8px;
`;

export const ActionBtn = styled.button<{ disabled?: boolean }>`
  width: 100%;
  height: 56px;
  background: ${props => props.disabled ? '#e0e0e0' : '#000000'};
  color: ${props => props.disabled ? '#999999' : '#ffffff'};
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;

  &:hover {
    background: ${props => props.disabled ? '#e0e0e0' : '#222222'};
    transform: ${props => props.disabled ? 'none' : 'translateY(-1px)'};
    box-shadow: ${props => props.disabled ? 'none' : '0 4px 12px rgba(0, 0, 0, 0.15)'};
  }

  &:active {
    transform: ${props => props.disabled ? 'none' : 'translateY(0)'};
  }

  &:focus {
    outline: 2px solid #000000;
    outline-offset: 2px;
  }

  @media (max-width: 768px) {
    height: 60px;
  }
`;

export const ErrorMessageText = styled.p`
  color: #dc2626;
  font-size: 14px;
  margin: 8px 0 0 0;
  line-height: 1.4;
`;

export const ErrorMessageDiv = styled.div<ErrorMessageProps>`
  visibility: ${({ visible }) => visible ? 'visible' : 'hidden'};
  height: ${({ visible }) => visible ? 'auto' : '0'};
`;

export const LoaderDiv = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const LoaderText = styled.p`
  color: #6b7280;
  font-size: 16px;
  text-align: center;
  margin: 0;
`;

export const LinkText = styled.p`
  text-align: center;
  font-size: 14px;
  color: #6b7280;
  margin-top: 28px;

  a {
    color: #000000;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.2s;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const FieldGroup = styled.div`
  margin-bottom: 24px;
`;

export const Title = styled.h3`
  font-size: 1.875rem;
  font-weight: 500;
  color: #000000;
`;

export const CustomText = styled.p`
  font-size: 1.5rem;
  color: #000000;
  line-height: 2.125rem;
`;
